import { render, staticRenderFns } from "./TwoActive.vue?vue&type=template&id=5bdd61f0&scoped=true&lang=pug"
import script from "./TwoActive.vue?vue&type=script&lang=js"
export * from "./TwoActive.vue?vue&type=script&lang=js"
import style0 from "./TwoActive.vue?vue&type=style&index=0&id=5bdd61f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd61f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdd61f0')) {
      api.createRecord('5bdd61f0', component.options)
    } else {
      api.reload('5bdd61f0', component.options)
    }
    module.hot.accept("./TwoActive.vue?vue&type=template&id=5bdd61f0&scoped=true&lang=pug", function () {
      api.rerender('5bdd61f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/TwoActive.vue"
export default component.exports